import React, { Component, Fragment } from 'react';
import styled from 'styled-components'
import PropTypes from 'prop-types';

// Constants
import { constants } from 'constants/index';

export const FieldWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    background: white;
    border: 1px solid ${constants.color.grey34};
    max-width: 350px;
`;
export const LabelWrapper = styled.div`
    font: 18px Open Sans, Helvetica, sans-serif;
    color: ${constants.color.grey34};
`;
export const InputWrapper = styled.input`

`;
export const CheckmarkWrapper = styled.span`
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    background-color: white;
    border: 1px solid ${constants.color.grey34};
    &:after {
        content: "";
        position: absolute;
        display: none;
    }
`;
export const ContainerWrapper = styled.label`
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    user-select: none;

    & > input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }

    &:hover input ~ ${CheckmarkWrapper} {
        background-color: #ccc;
    }

    & input:checked ~ ${CheckmarkWrapper} {
        background-color: white;
    }

    & input:checked ~ ${CheckmarkWrapper}:after {
        display: block;
    }

    & ${CheckmarkWrapper}:after {
        left: 9px;
        top: 5px;
        width: 5px;
        height: 10px;
        border: solid ${constants.color.primary};
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }
`;

const FormCheckboxField = ({ label, name, value, onfocusout, onChange, errorMessage, required, ...styleProps} ) => {
    return(
        <FieldWrapper
            key={name}
            style={styleProps.containerProps}
        >
            <ContainerWrapper>
                <LabelWrapper style={styleProps.labelProps}>{label}</LabelWrapper>
                <InputWrapper
                    type="checkbox"
                    name={name}
                    onChange={onChange}
                    checked={value}
                    test-label='input'
                    required={required}
                />
                <CheckmarkWrapper
                    style={styleProps.checkmarkProps}
                />
            </ContainerWrapper>
        </FieldWrapper>
    )
}

FormCheckboxField.propTypes = {
    /** Label to be displayed as the title */
    label: PropTypes.string.isRequired,
    /** Name of the field passed in, needed for react state changes */
    name: PropTypes.string.isRequired,
    /** Value of the field */
    value:  PropTypes.bool.isRequired,
    /** onBlur function used for validation  */
    onfocusout: PropTypes.func,
    /** onChange function to update the value */
    onChange: PropTypes.func,
    /** String that shows if there is an error with the input validation */
    errorMessage: PropTypes.string,
};

FormCheckboxField.defaultProps = {
    label: 'Placeholder label',
    name: 'placeholder',
    value: false,
    onfocusout: () => null,
    onChange:  () => null,
    errorMessage: null
};

export default FormCheckboxField;



// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/Forms/Components/FormCheckboxField.js